export default "https://assets.egbcdn.net/assets/packs/_/images/app/android/android-ru-4-3c5ebb9b9c38d9b2b197b88561704d48.png";